module.exports = __webpack_public_path__ + "img/next.8b1a5d3e.svg";